import { MapPin, Phone, Mail, Clock, Wrench } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-slate-950 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">
              Nous contacter
            </div>
            <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter">
              On s'occupe <br />
              <span className="text-slate-400">de votre véhicule.</span>
            </h2>

            <div className="mt-10 space-y-6">
              <ContactRow icon={MapPin} label="Adresse">
                881 Route de Bidaille, 74930 Scientrier
              </ContactRow>
              <ContactRow icon={Phone} label="Téléphone">
                <a
                  href="tel:+33649580664"
                  data-testid="contact-phone"
                  className="hover:text-blue-400 transition-colors"
                >
                  06 49 58 06 64
                </a>
              </ContactRow>
              <ContactRow icon={Mail} label="E-mail">
                <a
                  href="mailto:deschamps.auto74@gmail.com"
                  data-testid="contact-email"
                  className="hover:text-blue-400 transition-colors break-all"
                >
                  deschamps.auto74@gmail.com
                </a>
              </ContactRow>
              <ContactRow icon={Clock} label="Horaires d'ouverture">
                Lundi – Vendredi <br />
                <span className="text-slate-400">
                  09h00 – 12h00 · 14h00 – 18h00
                </span>
              </ContactRow>
            </div>
          </div>

          <div className="w-full rounded-lg overflow-hidden border border-slate-800 min-h-[360px] lg:min-h-[480px]">
            <iframe
              title="Localisation Garage Deschamps Auto"
              data-testid="contact-map"
              src="https://www.google.com/maps?q=881+Route+de+Bidaille,+74930+Scientrier&output=embed"
              className="w-full h-full min-h-[360px] lg:min-h-[480px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="h-8 w-8 grid place-items-center rounded-md bg-white text-slate-900">
              <Wrench size={16} strokeWidth={2.4} />
            </span>
            <span className="font-display font-black tracking-tight">
              Deschamps <span className="text-blue-400">Auto</span>
            </span>
          </div>
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Garage Deschamps Auto — Garage automobile multimarque · Scientrier (74)
          </p>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon: Icon, label, children }) {
  return (
    <div className="flex items-start gap-4">
      <div className="h-11 w-11 shrink-0 grid place-items-center rounded-md bg-slate-900 border border-slate-800 text-blue-400">
        <Icon size={18} />
      </div>
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-1">
          {label}
        </div>
        <div className="text-[15px] text-white leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
}
